import { render, staticRenderFns } from "./CreateEditCategory.vue?vue&type=template&id=2af6aa56&scoped=true&"
import script from "./CreateEditCategory.vue?vue&type=script&lang=js&"
export * from "./CreateEditCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af6aa56",
  null
  
)

export default component.exports